/* ============================================================
   Viori Personalizer 2.0 — Other Products carousel controller
   ------------------------------------------------------------
   - Multi-select pill row toggles slide visibility (OR logic)
   - One-way sync: top filter bar's product_type pre-selects
     pills here. Bottom selections do NOT propagate to top.
   - Empty state shown when active filters hide every slide.
   - Theme-editor safe — re-runs init() on shopify:section:load.
   ============================================================ */
(function (window, document) {
  'use strict';

  if (window.VioriOtherProducts) {
    /* Allow re-init from the section script's hook. */
  }

  var SECTION_SELECTOR = '[data-section="cust-v6-other-products"]';
  var unsubFromTop = null;

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function getActiveTypes(section) {
    var pills = $all(section, '[data-otherprods-pill]');
    return pills
      .filter(function (p) { return p.classList.contains('is-active'); })
      .map(function (p) { return p.getAttribute('data-otherprods-pill'); });
  }

  function applyFilter(section) {
    var active = getActiveTypes(section);
    var slides = $all(section, '.v-otherprods__slide');
    var visibleCount = 0;

    slides.forEach(function (slide) {
      var t = slide.getAttribute('data-product-type') || '';
      var visible = (active.length === 0) || (active.indexOf(t) !== -1);
      slide.classList.toggle('is-hidden', !visible);
      if (visible) visibleCount++;
    });

    /* Empty-state toggle. */
    var empty = section.querySelector('[data-otherprods-empty]');
    if (empty) {
      if (visibleCount === 0 && slides.length > 0) {
        empty.removeAttribute('hidden');
      } else {
        empty.setAttribute('hidden', '');
      }
    }

    /* Reset scroll so the user isn't stranded in a now-empty area. */
    var track = section.querySelector('[data-otherprods-track]');
    if (track) track.scrollLeft = 0;
  }

  function setPillActive(pill, active) {
    pill.classList.toggle('is-active', !!active);
    pill.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function bindPills(section) {
    var pills = $all(section, '[data-otherprods-pill]');
    pills.forEach(function (pill) {
      /* Avoid double-binding on re-init. */
      if (pill.__voBound) return;
      pill.__voBound = true;
      pill.addEventListener('click', function () {
        setPillActive(pill, !pill.classList.contains('is-active'));
        applyFilter(section);
      });
    });
  }

  /* Mirror the top filter bar's product_type selection to the bottom pills.
     One-way: top → bottom only. */
  function syncFromTop(section, topProductTypes) {
    var pills = $all(section, '[data-otherprods-pill]');
    var topSet = {};
    (topProductTypes || []).forEach(function (t) { topSet[t] = true; });

    var changed = false;
    pills.forEach(function (pill) {
      var t = pill.getAttribute('data-otherprods-pill');
      var shouldBeActive = !!topSet[t];
      if (pill.classList.contains('is-active') !== shouldBeActive) {
        setPillActive(pill, shouldBeActive);
        changed = true;
      }
    });
    if (changed) applyFilter(section);
  }

  function attachTopSubscriber(section) {
    /* Tear down previous subscription on re-init. */
    if (unsubFromTop && typeof unsubFromTop === 'function') {
      try { unsubFromTop(); } catch (_e) {}
      unsubFromTop = null;
    }

    if (!window.VioriFilters || typeof window.VioriFilters.subscribe !== 'function') {
      /* Top controller not ready yet — try again shortly. */
      window.setTimeout(function () { attachTopSubscriber(section); }, 200);
      return;
    }

    /* Initial mirror from current top state. */
    var snap = window.VioriFilters.getState ? window.VioriFilters.getState() : null;
    if (snap && snap.product_types) syncFromTop(section, snap.product_types);

    var unsub = window.VioriFilters.subscribe(function (newSnap) {
      syncFromTop(section, (newSnap && newSnap.product_types) || []);
    });
    if (typeof unsub === 'function') unsubFromTop = unsub;
  }

  function initSection(section) {
    bindPills(section);
    applyFilter(section);
    attachTopSubscriber(section);
  }

  function init() {
    var sections = $all(document, SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  window.VioriOtherProducts = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
